var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2837 6.08615C17.7405 5.83646 17.1038 5.94187 16.6657 6.354L14.7854 8.13972V6.84508C14.7854 5.36574 13.6108 4.1665 12.1617 4.1665H4.29068C2.84166 4.1665 1.66699 5.36574 1.66699 6.84508V13.9879C1.66699 15.4673 2.84166 16.6665 4.29068 16.6665H12.1617C13.6108 16.6665 14.7854 15.4673 14.7854 13.9879V12.6933L16.6745 14.479C16.9526 14.736 17.3139 14.8791 17.689 14.8808C17.8972 14.8803 18.1028 14.8346 18.2924 14.7469C18.8201 14.529 19.1658 14.0065 19.167 13.4254V7.40758C19.1644 6.82431 18.8147 6.30122 18.2837 6.08615ZM13.3338 14.0832C13.3338 14.5895 12.9268 14.9999 12.4247 14.9999H4.24291C3.74084 14.9999 3.33382 14.5895 3.33382 14.0832V6.74988C3.33382 6.24362 3.74084 5.83321 4.24291 5.83321H12.4247C12.9268 5.83321 13.3338 6.24362 13.3338 6.74988V14.0832ZM15.0005 10.8332L17.5005 13.3332V8.33321L15.0005 10.8332Z",
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.945ddd686657303ddf67e2bef5c394b9.svg";
export { ForwardRef as ReactComponent };